import type { UserApi } from '@/modules/users/types';

interface UserOption {
  label: string;
  value: string;
}

const getUserOptionLabel = (user: UserApi) => {
  const fullName = [user.firstName, user.lastName]
    .filter((value): value is string => !!value)
    .join(' ');

  if (fullName) {
    return fullName;
  }

  if (user.userName) {
    return user.userName;
  }

  return user.email || '';
};

export const mapUsersToSelectOptions = (users: UserApi[]): UserOption[] => {
  return users.map((user) => ({
    label: getUserOptionLabel(user),
    value: user.id,
  }));
};
